import { render } from "./Modal.vue?vue&type=template&id=335c509e"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=335c509e&lang=scss"
script.render = render

export default script